// components/ClockDisplay.js
import React, { useEffect, useState } from 'react';

export default function ClockDisplay({ 
  time, 
  onDoubleClick,
  size = "large",
  screensaver = false     // activa movimiento tipo salvapantallas
}) {

  const sizeClasses = {
    large: "text-[12vw] md:text-[10vw] lg:text-[12vw]",
    medium: "text-[8vw] md:text-[6vw] lg:text-[4vw]",
    small: "text-[4vw]",
    huge: "text-[20vw] md:text-[16vw] lg:text-[20vw]",
    auto: "text-[clamp(4rem, 20vw, 18rem)]"
  };

  // Estado para movimiento
  const [pos, setPos] = useState({ x: 0, y: 0 });
  const [dir, setDir] = useState({ x: 1, y: 1 });

  // Estado para color suave
  const [color, setColor] = useState('white');
useEffect(() => {
  if (!screensaver) return;

  const speed = 0.5; // velocidad px/frame

  const interval = setInterval(() => {
    const container = document.getElementById("screensaver-container");
    const clock = document.getElementById("screensaver-clock");
    if (!container || !clock) return;

    const cRect = container.getBoundingClientRect();
    const kRect = clock.getBoundingClientRect();

    const maxX = cRect.width - kRect.width;
    const maxY = cRect.height - kRect.height;

    setPos(prev => {
      let newX = prev.x + dir.x * speed;
      let newY = prev.y + dir.y * speed;
      let newDirX = dir.x;
      let newDirY = dir.y;

      if (newX <= 0) {
        newX = 0;
        newDirX = 1;
      } else if (newX >= maxX) {
        newX = maxX;
        newDirX = -1;
      }

      if (newY <= 0) {
        newY = 0;
        newDirY = 1;
      } else if (newY >= maxY) {
        newY = maxY;
        newDirY = -1;
      }

      // Actualiza la dirección
      setDir({ x: newDirX, y: newDirY });

      return { x: newX, y: newY };
    });
  }, 16); // ~60fps

  return () => clearInterval(interval);
}, [screensaver, dir]);
  // Cambio de color suave cada 5s
  useEffect(() => {
    if (!screensaver) return;

    const colors = ["#ffffff", "#ffeeee", "#eeffee", "#eeeeff", "#ffffee"];
    const colorInterval = setInterval(() => {
      const nextColor = colors[Math.floor(Math.random() * colors.length)];
      setColor(nextColor);
    }, 5000);

    return () => clearInterval(colorInterval);
  }, [screensaver]);

  return (
    <div 
      id="screensaver-container"
      className={`w-full h-full flex items-center justify-center ${
        onDoubleClick ? 'cursor-pointer' : ''
      }`}
      onDoubleClick={onDoubleClick}
      style={{
        position: screensaver ? "relative" : "static",
        overflow: screensaver ? "hidden" : "visible",
      }}
    >
      <span
        id="screensaver-clock"
        className={`font-mono leading-none select-none ${sizeClasses[size]}`}
        style={
          screensaver
            ? {
                position: "absolute",
                left: pos.x,
                top: pos.y,
                transition: "transform 0.03s linear",
                color: color,
                textShadow: "0 0 8px yellow, 0 0 0 "
              }
            : {}
        }
      >
        {time}
      </span>
    </div>
  );
}
